import _export from '../internals/export.js';
import nativePromiseConstructor from '../internals/native-promise-constructor.js';
import fails$1 from '../internals/fails.js';
import getBuiltIn$1 from '../internals/get-built-in.js';
import isCallable$1 from '../internals/is-callable.js';
import speciesConstructor$1 from '../internals/species-constructor.js';
import promiseResolve$1 from '../internals/promise-resolve.js';
import '../internals/redefine.js';
import { r as redefine$1 } from '../../../../../../_virtual/redefine.js';

var $ = _export;
var NativePromise = nativePromiseConstructor;
var fails = fails$1;
var getBuiltIn = getBuiltIn$1;
var isCallable = isCallable$1;
var speciesConstructor = speciesConstructor$1;
var promiseResolve = promiseResolve$1;
var redefine = redefine$1.exports; // Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829

var NON_GENERIC = !!NativePromise && fails(function () {
  // eslint-disable-next-line unicorn/no-thenable -- required for testing
  NativePromise.prototype['finally'].call({
    then: function () {
      /* empty */
    }
  }, function () {
    /* empty */
  });
}); // `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally

$({
  target: 'Promise',
  proto: true,
  real: true,
  forced: NON_GENERIC
}, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = isCallable(onFinally);
    return this.then(isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () {
        return x;
      });
    } : onFinally, isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () {
        throw e;
      });
    } : onFinally);
  }
}); // makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`

if (isCallable(NativePromise)) {
  var method = getBuiltIn('Promise').prototype['finally'];

  if (NativePromise.prototype['finally'] !== method) {
    redefine(NativePromise.prototype, 'finally', method, {
      unsafe: true
    });
  }
}
